import React, { useState, useEffect } from "react";

export const PendingStart = () => {
  const [pageLoading, setPageLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setPageLoading(false);
    }, 800);
  }, []);
  return (
    <>
      {pageLoading ? (
        <span className="DishKiChampionsTrophy-loader"></span>
      ) : (
        <div className="winner-container centerElement">
          <div
            className="winner-header mb-0"
            style={{
              position: "absolute",
              left: "50%",
              top: "50%",
              transform: "translate(-50%, 100%)",
            }}
          >
            <div className="winner-icon">
              <img src="/Images/try-agian.png" alt="Happy" />
            </div>
            <h5 className="mt-3">Next contest will be starting soon.</h5>
          </div>
        </div>
      )}
    </>
  );
};
